export const Footer = ({ onClick }) => (
  <footer>
    <p>
      The content generated by this web server is licensed under the Creative Commons Attribution 4.0 International (CC BY 4.0).
    </p>
    <a className="nav-link" href="#" onClick={() => onClick("impressum")}>Impressum</a>
  </footer>
)
